export default {
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filterable.js